/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import { getAccountsList } from "../../apis/companies/account";
import Button from "../Button";
import Filters from "../Filters";
import Modal, { ModalHeader } from "../Modal";
import { ControlTable } from "../Table";
import { CLIENT_SEARCH_OPTIONS } from "../../constants/CLIENT";
import { getParams } from "../../utils/params";
import systemAlert from "../../utils/systemAlert";
import { isEmpty } from "../../utils/lodashExtend";
import useForm from "../../hooks/useForm";
import { isFunction } from "lodash";

const defaultForm = {
  searchType: "name",
  searchText: "",
  order: [
    {
      idx: "desc",
    },
  ],
  page: 0,
  limit: 10,
};

const SelectClientInfo = ({ open, setOpen, type, form, setForm, searchType = "name" }) => {
  const [fields] = useState([
    { title: "거래처명", key: "name" },
    { title: "거래처코드", key: "code" },
    { title: "대표자명", key: "ceoName" },
    {
      title: "구분",
      key: "type",
      onTranslator: {
        list: [
          {
            label: "사업자",
            value: 0,
          },
          {
            label: "개인",
            value: 1,
          },
          {
            label: "외국인",
            value: 2,
          },
        ],
      },
    },
    { title: "사업자등록번호", key: "comNum" },
    { title: "주소", key: "address" },
    { title: "전화번호", key: "mobile" },
  ]);

  const searchRef = useRef(null);
  const [filters] = useState([
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: CLIENT_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
      innerRef: searchRef,
    },
  ]);

  const {
    values,
    setValues,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedData,
    setSelectedData,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm({
    ...defaultForm,
    searchType,
    searchText:
      searchType === "comNum"
        ? (type === "purchase" ? form.supBizNo : form.byrBizNo)
        : (type === "purchase" ? form.supCorpName : form.byrCorpName) || ""

  });

  useEffect(() => {
    if (open) {
      submit(values);
      setSubmit(submit);
    }
  }, [open]);

  useEffect(() => {
    if (searchRef && searchRef.current && isFunction(searchRef.current.focus)) {
      searchRef.current.focus();
    }
  }, [searchRef.current]);

  const submit = (params) => {
    setIsLoading(true);
    getAccountsList({
      ...getParams(params),
    })
      .then((res) => {
        setTotal(get(res, "data.count"));
        setList(get(res, "data.accounts"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancel = () => {
    setSelectedData({});
    setValues(defaultForm);
    setOpen(false);
  };

  const handleOnSupply = () => {
    if (isEmpty(selectedData)) return systemAlert("거래처를 선택해주세요.");

    const {
      address,
      addressDetail,
      idx,
      industryType,
      industrySect,
      sectNum,
      name,
      comNum,
      email,
      taxEmail1,
      taxEmail2,
      ceoName,
    } = selectedData;

    if (type === "sales") {
      setForm({
        ...form,
        clientIdx: idx,
        byrBizNo: comNum,
        byrBizSubNo: sectNum,
        byrCorpName: name,
        byrRepName: ceoName,
        byrAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        byrBizCategory: industryType,
        byrBizItem: industrySect,
        byrEmail1: taxEmail1 || email,
        byrEmail2: taxEmail2,
      });
    } else {
      setForm({
        ...form,
        clientIdx: idx,
        supBizNo: comNum,
        supBizSubNo: sectNum,
        supCorpName: name,
        supRepName: ceoName,
        supAddress: isEmpty(address) ? "" : isEmpty(addressDetail) ? address : `${address} ${addressDetail}`,
        supBizCategory: industryType,
        supBizItem: industrySect,
        supEmail: taxEmail1 || taxEmail2 || email,
      });
    }

    cancel();
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-client-info">
        <ModalHeader>거래처 불러오기</ModalHeader>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={values}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          isSelect
          setSelectedData={setSelectedData}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SelectClientInfo;
